import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class EnvironmentVariablesService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Create environment variable
     * @returns EnvVariable New environment variable created.
     * @throws ApiError
     */
    createEnvVariable({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/env-variables', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                409: `Conflict.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of environment variables
     * @returns EnvVariableList OK.
     * @throws ApiError
     */
    listEnvVariables({ orgId, projectId, after, before, sort = '-id', limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/env-variables', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'limit': limit,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update environment variable
     * @returns EnvVariable New environment variable created.
     * @throws ApiError
     */
    updateEnvVariable({ orgId, projectId, envVariableId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/projects/{projectId}/env-variables/{envVariableId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'envVariableId': envVariableId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                409: `Conflict.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get environment variable
     * @returns EnvVariable OK.
     * @throws ApiError
     */
    getEnvVariableById({ orgId, projectId, envVariableId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/env-variables/{envVariableId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'envVariableId': envVariableId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete environment variable
     * @returns any No Content.
     * @throws ApiError
     */
    deleteEnvVariable({ orgId, projectId, envVariableId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/env-variables/{envVariableId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'envVariableId': envVariableId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get list of environment variables for internal use only
     * @returns EnvVariable OK.
     * @throws ApiError
     */
    listEnvVariablesInternal({ orgId, projectId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/internal-env-variables', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=EnvironmentVariablesService.js.map